const routes= [
  { name: 'browser', path: '/?page&artist&year&genre&label&country&type&alpha&status&filter',
    queryParamsMode: 'loose', nullFormat: 'hidden'},
  { name: 'artist', path: '/:artist<[^/?#\\[\\]]+>' },
  { name: 'album', path: '/:artist<[^/?#\\[\\]]+>/:album<[^/?#\\[\\]]+>' }
]
export default routes;
